import { connect, StreamClient } from 'getstream';
import { PropsWithChildren, useState } from 'react';

import { useStreamChatAuthorizationQuery } from 'shared/graphql';
import { useHasSession } from 'shared/hooks';
import { recordDebug } from 'shared/utils/record';

import { StreamChatContext } from './StreamChatContext';

const PUBLIC_STREAMCHAT_API_KEY = process.env.REACT_APP_PUBLIC_STREAMCHAT_API_KEY as string;
const STREAMCHAT_APP_ID = process.env.REACT_APP_STREAMCHAT_APP_ID as string;

export function StreamChatProvider(props: PropsWithChildren<unknown>) {
  const [client, setClient] = useState<StreamClient | null>(null);

  const hasSession = useHasSession();

  const { loading } = useStreamChatAuthorizationQuery({
    // Prevents the query to be executed when the user is not logged in.
    skip: !hasSession,

    onCompleted({ authorization }) {
      const token = authorization?.token;

      if (!token) {
        return;
      }

      recordDebug('Setting up the StreamChat client');
      setClient(connect(PUBLIC_STREAMCHAT_API_KEY, token, STREAMCHAT_APP_ID));
    },
  });

  return (
    <StreamChatContext.Provider value={{ streamChatClient: client, loading }}>
      {props.children}
    </StreamChatContext.Provider>
  );
}
